import { render, staticRenderFns } from "./profit.vue?vue&type=template&id=522926bf&scoped=true"
import script from "./profit.vue?vue&type=script&lang=js"
export * from "./profit.vue?vue&type=script&lang=js"
import style0 from "./profit.vue?vue&type=style&index=0&id=522926bf&prod&lang=css"
import style1 from "./profit.vue?vue&type=style&index=1&id=522926bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522926bf",
  null
  
)

export default component.exports